import { getAllBrand } from "../../../../../apis/Brand";
import { getColorsbyKeyword } from "../../../../../apis/Product";
import { getAllSeller } from "../../../../../apis/Seller";

// fields/productFormFields.js
export const productFormFields = (product = {}, sizes = []) => {
    let fields = [
        {
            type: "switch",
            name: "out_of_stock",
            label: "Out of Stock",
            defaultValue: product.out_of_stock ?? false,
        },
        {
            type: "text",
            name: "affiliated_url",
            label: "Affiliated Link",
            readOnly: true,
            value: product.affiliated_url,
        },
        {
            type: "text",
            name: "original_product_id",
            label: "original_product_id",
            readOnly: true,
            value: product.original_product_id,
            hidden: true,
        },
        {
            type: "text",
            name: "name",
            label: "Product Name",
            multiline: true,
            minRows: 1,
            maxRows: 3,
            required: true,
            value: product.name,
        },
        {
            type: "text",
            name: "description",
            label: "Description",
            multiline: true,
            minRows: 2,
        },
        {
            type: "text",
            name: "material",
            label: "Material",
            multiline: true,
            minRows: 1,
        },
        {
            type: "text",
            name: "delivery",
            label: "Delivery",
            multiline: true,
            minRows: 1,
        },
        {
            type: "text",
            name: "size_fit",
            label: "Size and Fit",
            multiline: true,
            minRows: 1,
        },
       
        {
            type: "custom",
            component: "category", // handled in switch
        },
        {
            type: "autocomplete",
            name: "brand",
            label: "Brand",
            fetchOptions: getAllBrand,
            required: true,
        },
        {
            type: "autocomplete",
            name: "seller",
            label: "Seller",
            fetchOptions: getAllSeller,
            required: true,
        },
        {
            type: "autocomplete",
            name: "primary_color",
            label: "Primary Color",
            fetchOptions: getColorsbyKeyword,
            required: true,
        },
        {
            type: "autocomplete",
            name: "secondary_color",
            label: "Secondary Color",
            fetchOptions: getColorsbyKeyword,
        },
        {
            type: "price_group",
            discounted_price: product.discounted_price,
            mrp: product.mrp,
        },
    ];
	if(sizes.length>0){
		fields=[...fields,{
            type: "sizes",
            sizes, // custom renderer for available sizes
        },
        {
            type: "hidden",
            name: "size_detail",
            label: "Size Detail",
        },]
		}
    return fields;
};
